import $ from 'jquery';

$(function () {

    // make video play in modal on overlay click
    $('.sub-video__poster-overlay').on('click', function () {

        var target = $('.modal__video'),
            video = $(this).next('.sub-video__player').clone(),
            parent = $(this).parent('.sub-video__content');

        // add video to modal
        target.html(video);
        video.addClass('sub-video__player--modal').attr({
            'controls': true,
            'autoplay': true
        });

        // open modal
        NS.openOverlay();
        NS.openModal('modal--video');

    });

    // load all images in each gallery into an array
    if (NS.imageGalleries) {
        var $galleries = {};
        $.each($('.sub-gallery__list'), function () {
            var $gallery = [];
            $.each($(this).children('.sub-gallery__item'), function () {
                var image = {
                    url: $(this).find('img').data('fullsrc'),
                    title: $(this).find('img').data('title'),
                    description: $(this).find('img').data('description')
                };
                $gallery.push(image);
            });
            $galleries[$(this).attr('id')] = $gallery;
        });
    }

    // move to prev / next image in gallery
    var galleryMove = function (direction) {

        var galleryId = $('.modal--image').data('gallery-id'),
            $gallery = $galleries[galleryId],
            image = $('.modal__image img').attr('src'),
            amount = $gallery.length - 1,
            current = $gallery.map(function(i) { return i.url; }).indexOf(image);
            next = current + 1,
            prev = current - 1;

        // go around if next/prev is last
        if (next > amount) {
            next = 0;
        }
        if (prev < 0) {
            prev = amount;
        }

        if (direction == 'next') {
            var moveToImage = $gallery[next];
        } else {
            var moveToImage = $gallery[prev];
        }

        // change backdrop
        $('.overlay--image').css('background-image', 'url(' + moveToImage.url + ')');

        // change image
        $('.modal__image img').attr('src', moveToImage.url);

        // change title
        $('.modal__image-header').text(moveToImage.title);

        // change description
        $('.modal__image-text').text(moveToImage.description);
    };

    // touch controls for image galleries
    var touchDownX = null,
        touchDownY = null,
        touchMoving = false;

    var imageGalleryTouchCancel = function() {
        $('.modal__content--image').unbind('touchmove');
        touchDownX = null,
        touchDownY = null,
        touchMoving = false;
    };
    var imageGalleryTouchStart = function(event) {
        var e = event.originalEvent;

        if (e.touches.length == 1) {
            touchDownX = e.touches[0].clientX;
            touchDownY = e.touches[0].clientY;
            touchMoving = true;
            $('.modal__content--image').on('touchmove', '.modal__image', imageGalleryTouchMove);
        }
    };
    var imageGalleryTouchMove = function(event) {
        var f = event.originalEvent;

        if (!touchDownX || !touchDownY) {
            return;
        }

        if (touchMoving) {
            var touchUpX = f.touches[0].clientX,
                touchUpY = f.touches[0].clientY,
                touchDiffX = touchDownX - touchUpX,
                touchDiffY = touchDownY - touchUpY;

            if (Math.abs(touchDiffX) > Math.abs(touchDiffY)) {
                if (touchDiffX > 0 && Math.abs(touchDiffX) > 50) {
                    imageGalleryTouchCancel();
                    galleryMove('next');

                } else if (Math.abs(touchDiffX) > 50) {
                    imageGalleryTouchCancel();
                    galleryMove('prev');
                }
            }
        }
    };

    // show gallery image in modal on click
    $('.sub-gallery__item').on('click', function () {

        var image = $(this).find('img').data('fullsrc'),
            header = $(this).find('.sub-gallery__header').text(),
            text = $(this).find('.sub-gallery__text').text(),
            $textBox = $(this).children('.sub-gallery__text-box'),
            $target = $('.modal--image'),
            $targetFrame = $('.modal__image'),
            $targetHeader = $('.modal__image-header'),
            $targetText = $('.modal__image-text'),
            $targetCite = $('.modal__image-cite'),
            citePattern = /.*\s*((Photo|Foto): .+)$/i,
            $loadBar = $('<div></div>').addClass('sub-gallery__load'),
            galleryId = $(this).parent('.sub-gallery__list').attr('id');

        // add text to modal
        $targetHeader.html(header);

        if (citePattern.test(text))
        {
            var imageAttribution = citePattern.exec(text)[1];
            $targetCite.html(imageAttribution).show();

            var description = text.replace(imageAttribution, '');
            if (description.length > 0)
            {
                $targetText.html(description);
            }
        }
        else
        {
            $targetText.html(text);
            $targetCite.html('').hide();
        }

        // add galleryId to modal
        $target.attr('data-gallery-id', galleryId);

        // show load bar while loading image
        $targetFrame.html('<img>');
        var $loadImage = $targetFrame.children('img');
        $textBox.append($loadBar);
        $loadImage.on('load', function (e) {
            // add image to overlay
            $('.overlay--image').css('background-image', 'url(' + image + ')');

            // show modal
            NS.openOverlay();
            NS.openModal('modal--image');

            // remove load bar
            $loadBar.remove();

            // remove load function
            $loadImage.unbind('load');
        });
        $loadImage.attr('src', image);

        // allow keystrokes
        $('body').on('keydown.imageGallery', function (e) {

            var currentImage = $('.modal__image img').attr('src');

            // prev image
            if(e.which == 37) {
                galleryMove('prev');
            // next image
            } else if (e.which == 39) {
                galleryMove('next');
            // escape
            } else if (e.which == 27) {
                NS.closeOverlay();
            }
        });
    });

    // allow touch on gallery when image is showing in modal
    $('.modal__content--image').on('touchstart', '.modal__image', imageGalleryTouchStart);
});
